module.exports = __webpack_public_path__ + "d13dbdcd42a10ec2f76aff10d3554bc9.svg";